import { Icon } from '@repo/ui';
import c from 'classnames';

import styles from './TinyAICloseButton.module.scss';

interface TinyAICloseButtonProps {
  onClick: () => void;
  isKeyboardVisible?: boolean;
}

export const TinyAICloseButton = ({
  onClick,
  isKeyboardVisible = false,
}: TinyAICloseButtonProps) => {
  return (
    <button
      className={c(styles.closeButton, {
        [styles.hidden]: isKeyboardVisible,
      })}
      onClick={onClick}
      aria-label='Close TinyAI'
    >
      <Icon name='closeSm' />
    </button>
  );
};
